import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { string, oneOf, func } from 'prop-types';
import { Button } from '@thd-olt-component-react/core-ui';
import { SAMDualPathTooltip } from './SAMDualPathTooltip';
import { ProductAddOnsPod } from '../../common/product-add-ons-pod';
import { dualPathContactInformation } from '../../../utils/product-add-on-constants';
import styles from './sam-dual-path.scss';

const SAMDualPath = ({
  channel,
  itemId,
  onChange,
  modelNumber,
}) => {
  const [checked, setChecked] = useState(false);
  const tooltipButtonRef = useRef(null);
  const skuType = 'Special Order';
  const baseSamUrl = 'https://sam.fit.homedepot.com/';
  const samUrl = baseSamUrl + `?sku=${itemId}&skuType=${skuType}&modelNumber=${modelNumber}&leadSource=PIP`;

  const cx = classNames.bind(styles);
  const classes = cx(
    'product-add-ons__schedule-a-measure',
    { 'u--hide': !checked }
  );

  const handleChange = (evt) => {
    LIFE_CYCLE_EVENT_BUS.trigger('SAM-dual-path.change', { isOptedIn: !checked, itemId });
    onChange({
      itemId,
      checked: evt.target.checked,
      addOnType: evt.target.value
    });
    setChecked(!checked);
  };

  useEffect(() => {
    const tippy = tooltipButtonRef?.current?._tippy;
    if (tippy && !checked) tippy.hide();
  }, [checked]);

  const ContactInformation = () => (
    <div className="sam-dual-path__install-text">Or call
      <a className="u__default-link" href={`tel:${dualPathContactInformation.brio_inaisle_sfi_whtr.tel}`}>
        {dualPathContactInformation.brio_inaisle_sfi_whtr.label}
      </a>
    </div>
  );

  return (
    <>
      <ProductAddOnsPod
        channel={channel}
        heading="Get Expert In-Home Installation"
        subHeading="A local pro will take care of the job for you."
        icon="use-and-care-manual.svg"
        iconHeight={36}
        iconWidth={36}
        onChange={handleChange}
        tooltip={(
          <SAMDualPathTooltip
            channel={channel}
            ref={tooltipButtonRef}
          />
        )}
        userOptions={[
          {
            id: 'item ID',
            value: 'SAM-dual-path',
            checked,
            label: 'Add In-Home Installation'
          }
        ]}
      >
        <>
          <Button
            className={classes}
            href={samUrl}
            tag="a"
            target="_blank"
            outline={false}
          >
            Schedule a Measure
          </Button>
          {
            checked && <ContactInformation />
          }
        </>
      </ProductAddOnsPod>
    </>
  );
};

SAMDualPath.displayName = 'ProductAddOns-SAMDualPath';

SAMDualPath.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  itemId: string.isRequired,
  onChange: func.isRequired,
  modelNumber: string.isRequired,
};

SAMDualPath.defaultProps = {
  channel: 'desktop',
};

export { SAMDualPath };